import { COLUMN_TAG_CODE } from "../../constants/column-types";
import { SearchTerm } from "./SearchTerm";

const VingcardTransactionSearch: SearchTerm[] = [
    {
        heading: "Type",
        accessor: "eventDescription",
        searchOnName: "eventDiscription",
        translationKey: "type"
    },
    {
        heading: "Door",
        accessor: "doorId",
        searchOnName: "doorId",
        translationKey: "door"
    },
    {
        heading: "Registration Number",
        accessor: "registrationNumber",
        searchOnName: "registrationNumber",
        translationKey: "registrationNumber"
    },
    {
        heading: "Card Number",
        accessor: "cardNameID",
        searchOnName: "cardNameID",
        translationKey: "tagCode"
    }
];

export default VingcardTransactionSearch;
